import React from "react";
import { IndexFormInner } from "../IndexFormInner";
import {
  FIELDS,
  INITIAL_VALUES,
  SCHEMA,
  useCreateVectorIndex
} from "./useCreateVectorIndex";

export const VectorIndexForm = ({ onClose }: { onClose: () => void }) => {
  const { onCreate } = useCreateVectorIndex();

  return (
    <IndexFormInner<typeof INITIAL_VALUES, typeof FIELDS, typeof SCHEMA>
      initialValues={INITIAL_VALUES}
      schema={SCHEMA}
      fields={FIELDS}
      onCreate={onCreate}
      onClose={onClose}
    />
  );
};
